/**
 * `localStorage` kaliti — backend spec (`packages/core/src/locale.ts`) dagi
 * `DEFAULT_LOCALE`/`X-Locale` bilan bir xil ikki tilni ifodalaydi.
 *
 * ⚠️ Bu fayl `import.meta.glob` ISHLATMAYDI — `index.ts` (haqiqiy i18next
 * ishga tushirish moduli) dan ATAYLAB ajratilgan, chunki `import.meta.glob`
 * faqat Vite tomonidan bundle qilinganda ishlaydi. `bun test` Vite orqali
 * o'tmaydi, ya'ni `index.ts`ni sinov faylidan (to'g'ridan-to'g'ri yoki
 * boshqa modul orqali) import qilish testni yiqitardi. `useChangeLocale`,
 * `AntdProvider` kabi sinov qamroviga tushishi mumkin bo'lgan fayllar
 * shu yerdan (yoki to'g'ridan-to'g'ri `i18next` paketidan) import qiladi,
 * `index.ts`dan EMAS.
 */
export const LOCALE_STORAGE_KEY = "skud-locale";

export type AppLocale = "uz" | "ru";

export const DEFAULT_LOCALE: AppLocale = "ru";

export function isAppLocale(value: unknown): value is AppLocale {
	return value === "uz" || value === "ru";
}

/** `localStorage`da saqlangan qiymat bo'lsa o'shani, bo'lmasa standart `"ru"`ni qaytaradi. */
export function readStoredLocale(): AppLocale {
	try {
		const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY);
		return isAppLocale(stored) ? stored : DEFAULT_LOCALE;
	} catch {
		// Xususiy rejim yoki sayt ma'lumotlari bloklangan — standart bilan davom etamiz.
		return DEFAULT_LOCALE;
	}
}
